import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import './app/common/utils/extensions';
import { ApplicationRef } from '@angular/core';
import { environment } from './environments/environment';

console.log('[Angular] main.ts executed');
if (environment.production) {
  // @ts-ignore: write-only webpack directive, intentionally never read
  __webpack_public_path__ = environment.frontendDomain;
}
(window as any).__webpack_public_path__ = environment.frontendDomain;
console.log('window.__webpack_public_path__', (window as any).__webpack_public_path__);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((moduleRef) => {
    // Trigger global change detection after Angular bootstraps
    // This ensures all components get ng-star-inserted class when inserted
    const appRef = moduleRef.injector.get(ApplicationRef);
    setTimeout(() => {
      appRef.tick();
      console.log('[Angular] Global change detection triggered after bootstrap');
    }, 100);
  })
  .catch((err) => {
    console.error(err);
    console.error('err.toString()', err.toString());

    if (err.toString().includes('NG0908')) {
      window.location.reload();
    }
  });
